import { PagePreviewResponseModel, PagePreviewRequestModel } from '../../../models/customerPageDatas.model';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../../services/shared/utils/utils.service';
import { RoleType } from '../../enums/role-type/role-type.module';
import { Page } from '../../../models/page.model';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { CustomerPageDataService } from '../../../services/customerPageData/customerPageData.service';
import { LocalStorageService } from '../../../services/shared/local-storage/local-storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { LoadingService } from '../../../services/loading/loading.service';

@Component({
  selector: 'app-preview-choose-modal',
  templateUrl: './preview-choose-modal.component.html',
  styleUrl: './preview-choose-modal.component.css'
})
export class PreviewChooseModalComponent {

  private destroy$ = new Subject<void>();

  customerForm: FormGroup;
  page: Page = {};
  constructor(private dialogRef: MatDialogRef<PreviewChooseModalComponent>,
    private utils: UtilsService,
    private customerPageDataService: CustomerPageDataService,
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    private lStorage: LocalStorageService,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    @Inject(MAT_DIALOG_DATA) public data: { page: Page, customerCode: string, soprodId: string }) {
    this.page = data.page;
    this.customerForm = this.fb.group({
      roleSelected: RoleType.CUSTOMER,
      customerCode: [data.customerCode, [this.customerCodeValidator]],
      soprodId: data.soprodId
    });
  }

  roleTypes = Object.keys(RoleType)
    .filter(key => isNaN(Number(key)))
    .map(key => ({ key, value: RoleType[key as keyof typeof RoleType] }));

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCancel(): void {
    var preSelected = {
      customerCode: this.customerForm.get('customerCode')?.value,
      soprodId: this.customerForm.get('soprodId')?.value
    }
    this.dialogRef.close(preSelected);
  }

  onConfirm(): void {
    if (this.customerForm.valid) {
      const roleSelected: RoleType = parseInt(this.customerForm.get('roleSelected')?.value);
      const customerCode: string = this.customerForm.get('customerCode')?.value;
      const soprodId: string = this.customerForm.get('soprodId')?.value;

      var fakePageId = this.utils.generateGUID();
      const pageCopy = { ...this.page };
      if (pageCopy.id === '00000000-0000-0000-0000-000000000000') {
        pageCopy.id = fakePageId;
      }

      var newPreview: PagePreviewRequestModel = {
        role: roleSelected,
        page: pageCopy,
        customerCode: customerCode,
        soprodId: soprodId
      }
      this.loadingService.show();
      this.customerPageDataService.getCustomerPagePreviewDatas(newPreview)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: PagePreviewResponseModel) => {
          if (data.customerPage !== undefined && data.customerPage !== null && data.customerPage.blocks!.length > 0) {
            var ttl = 60 * 60 * 1000; // 1 hour
            const previewData = {
              page: data.customerPage,
              customer: data.customer,
              customerPageDatas: data.customerPageDatas,
              role: roleSelected
            };

            const roleStorageKey = `preview_${pageCopy.id}_${roleSelected}`;
            this.lStorage.setItemWithExpiry(roleStorageKey, previewData, ttl);

            //redirect
            window.open('/customer/' + data.customer.id + '/page/' + pageCopy.id + '/preview?role=' + roleSelected, roleStorageKey);
            this.dialogRef.close(newPreview);
          }
          else {
            if (typeof data === 'string') {
              this.snackBar.showError(this.translationService.translate(data));
            } else {
              this.snackBar.showWarning(this.translationService.translate('Page or blocks set to not show in this role type'));
            }
            this.dialogRef.close(newPreview);
          }
          this.loadingService.hide();
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error on creating page preview'));
          this.dialogRef.close(newPreview);
          this.loadingService.hide();
        }
      });
    }
  }

  customerCodeValidator(control: any) {
    let value = control.value || '';
    const cleanedValue = value.replace(/[^0-9]/g, '');

    if (cleanedValue !== value) {
      control.setValue(cleanedValue, { emitEvent: false });
    }

    if (cleanedValue === '' || /^[0-9]{0,8}$/.test(cleanedValue)) {
      return null;
    }

    return { invalidCustomerCode: true };
  }
}
